import {
  CLASSES,
  FOLLOWER_COLUMN_FIELD,
  HANDRAISER_COLUMN_FIELD,
  HISTORIC_FOLLOWER_COLUMN_FIELD,
  HISTORIC_FOLLOWER_YEARS,
} from 'routes/highschools/ExploreTable/gradYears'

import { HSExploreViews } from './types'

export const internalDefaultViews: HSExploreViews = {
  views: [
    {
      id: '_default_OVERVIEW',
      name: 'Overview',
      orderModel: {
        name: 0,
        target: 50,
        ceebCode: 100,
        state: 200,
        city: 300,
        zipCode: 400,
        schoolType: 500,
        isActive: 600,
        nextVisitDate: 700,
        numHandraisers: 950,
        numFollowers: 960,
        numHistoricFollowers: 970,
        hasCounselorSuggestions: 1000,
        isTitle1Eligible: 1100,
        religiousAffiliation: 1200,
        locale: 1300,
        geomarket: 1400,
        seniorClassSize: 1500,
        title1Program: 1600,
        pctFreeReducedLunch: 1700,
        pctFirstGenerationStudents: 1800,
        pctAttendFourYearCollegeStudents: 1900,
        pctAttendTwoYearCollegeStudents: 2000,
        pctAsianStudents: 2100,
        pctBlackAfricanAmericanStudents: 2200,
        pctHispanicLatinoStudents: 2300,
        pctNativeAmericanStudents: 2400,
        pctWhiteCaucasianStudents: 2500,
      },
      sortModel: {
        field: 'name',
        sort: 'asc',
      },
      visibilityModel: {
        name: true,
        city: true,
        zipCode: true,
        schoolType: true,
        state: true,
        seniorClassSize: true,
        title1Program: true,
        pctFreeReducedLunch: true,
        pctFirstGenerationStudents: true,
        pctAttendFourYearCollegeStudents: true,
        pctAttendTwoYearCollegeStudents: true,
        pctAsianStudents: true,
        pctBlackAfricanAmericanStudents: true,
        pctHispanicLatinoStudents: true,
        pctNativeAmericanStudents: true,
        pctWhiteCaucasianStudents: true,
        isActive: true,
        ceebCode: true,
        isTitle1Eligible: true,
        religiousAffiliation: true,
        locale: true,
        numHandraisers: true,
        numFollowers: true,
        numHistoricFollowers: true,
        hasCounselorSuggestions: true,
        geomarket: true,
        nextVisitDate: true,
        target: true,
      },
      widthModel: {},
      filterModel: {
        isActive: true,
      },
      pinnedModel: {
        left: ['name'],
        right: [],
      },
      columnConfigModel: {
        [HANDRAISER_COLUMN_FIELD]: { classes: [...CLASSES] },
        [FOLLOWER_COLUMN_FIELD]: { classes: [...CLASSES] },
        [HISTORIC_FOLLOWER_COLUMN_FIELD]: { years: [...HISTORIC_FOLLOWER_YEARS] },
      },
    },
  ],
  defaultViewId: '_default_OVERVIEW',
}

export const normalizeOrderModel = (orderModel: { [key: string]: number }): { [key: string]: number } => {
  const defaultKeys = Object.keys(internalDefaultViews.views[0]?.orderModel ?? {})
  const allKeys = [...new Set([...Object.keys(orderModel), ...defaultKeys])]
  const existingValues = Object.entries(orderModel)
    .filter(([key]) => defaultKeys.includes(key))
    .map((entry) => entry[1])
    .sort((a, b) => a - b)

  const valueMap = new Map(existingValues.map((value, index) => [value, index + 1]))
  const newColumnStartIndex = existingValues.length + 1

  return allKeys.reduce(
    (acc, key) => {
      const value = orderModel[key]
      if (defaultKeys.includes(key)) {
        acc[key] = valueMap.get(value) ?? 1
      } else {
        acc[key] = newColumnStartIndex + (value ?? 0)
      }
      return acc
    },
    {} as { [key: string]: number },
  )
}

export const standardViews = {
  ...internalDefaultViews,
  views: internalDefaultViews.views.map((v) => ({
    ...v,
    orderModel: normalizeOrderModel(v.orderModel),
  })),
}
